import { Component } from '@angular/core';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['../app.component.css']
})
export class PublicComponent {
  
}
